import { isNonEmptyArray, isNonEmptyObject, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { slugifyString } from "utils";
import { dispatch } from "store/store";

import { setProposalSearchBar } from "./proposals";
import { setAwardSearchBar } from "./awardList";
import { setProjectSearchBar } from "./projectList";

import { facetedSearch as constants } from "store/constants";

const hasSearchQuery = facetSearch => key => isNonEmptyString(facetSearch[key]);

const onSearchChange = ({ facetSearch, facets }, storeSearchFragments) => {
	const searchFragments = {};

	Object.keys(facetSearch)
		.filter(hasSearchQuery(facetSearch))
		.forEach(key => {
			const facet = facets.find(({ key: facetKey }) => facetKey === key);
			const searchKey = facet?.searchKey || undefined;

			if (searchKey) {
				searchFragments[searchKey] = facetSearch[key];
			}
		});

	storeSearchFragments(searchFragments);

	return searchFragments;
};

const getActualFacets = (storedSearch) => {
	let actualFacets = {};

	if (isNonEmptyObject(storedSearch)) {
		actualFacets = Object.keys(storedSearch)
			.reduce((acc, item) => {
				acc[slugifyString(item)] = storedSearch[item];

				return acc;
			}, {});
	}

	return actualFacets;
};

const mapAvailableColumnsToFacetedSearch = (availableColumns, searchByKey = false) => {
	if (isNonEmptyArray(availableColumns)) {
		return availableColumns.map(({ keys, id, columnHeader, type }) => ({
			fieldKeys: [ ...keys ],
			key: id,
			value: id,
			text: columnHeader,
			searchKey: searchByKey ? keys[0] : columnHeader,
			facetType: type
		}));
	}

	return [];
};

export const setProposalListFacetedSearchKeys = (payload) => {
	dispatch({
		type: constants.SET_PROPOSAL_LIST_FACETED_SEARCH_KEYS,
		payload: mapAvailableColumnsToFacetedSearch(payload),
	});
};

export const setAwardListFacetedSearchKeys = (payload) => {
	dispatch({
		type: constants.SET_AWARD_LIST_FACETED_SEARCH_KEYS,
		payload: mapAvailableColumnsToFacetedSearch(payload),
	});
};

export const setProjectListFacetedSearchKeys = (payload) => {
	dispatch({
		type: constants.SET_PROJECT_LIST_FACETED_SEARCH_KEYS,
		payload: mapAvailableColumnsToFacetedSearch(payload, true),
	});
};

export const setProposalListActualFacets = (storedSearch) => {
	dispatch({ type: constants.SET_PROPOSAL_LIST_ACTUAL_FACETS, payload: getActualFacets(storedSearch) });
};

export const setAwardListActualFacets = (storedSearch) => {
	dispatch({ type: constants.SET_AWARD_LIST_ACTUAL_FACETS, payload: getActualFacets(storedSearch) });
};

export const setProjectListActualFacets = (storedSearch) => {
	dispatch({ type: constants.SET_PROJECT_LIST_ACTUAL_FACETS, payload: getActualFacets(storedSearch) });
};

export const onChangeProposalListSearch = (payload) => {
	return onSearchChange(payload, setProposalSearchBar);
};

export const onChangeAwardListSearch = (payload) => {
	return onSearchChange(payload, setAwardSearchBar);
};

export const onChangeProjectListSearch = (payload) => {
	return onSearchChange(payload, setProjectSearchBar);
};
